import * as Result from '../../../services/api/resultsRecommendation'
import { useApiRequest } from '../../useApiRequest'

export function useGetOrganizationRecommendations () {
  const { data, loading, error } = useApiRequest(Result.fetchAllResults())

  return { data, loading, error }
}
